import React, {Component} from 'react'
import BooksContainer from './../../../containers/BooksContainer'

class Books extends Component {
  render () {
    return (
      <div>
        <div className='container'>
          <BooksContainer />
        </div>
      </div>
    )
  }
}

export default Books



// WEBPACK FOOTER //
// ./src/routes/Landing/Books/index.js